// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1eFb4","inputDescription":"styles_inputDescription__16bMn"};